import {
    IAEAColumnDefinition, IFEHeaderDto, IFEStep1Dto, IFEStep2Dto, IFEStep3Dto, IFEStep4Actividad, IFEStep4ActividadAnio, IFEStep4ActivitiesDtoModel,
    IFEStep4Dto, IFEStep4IndicadoresDtoModel, IFEStep4IndicadorMri, IFEStep4IndicadorObjetivoAnio, IFEStep4MriIndicadorAnio, IFEStep4MriIndicadorDtoModel, IFEStep4ResultadoEsperadoDetalle, IFEStep4ResultadoEsperadoDetalleAnio,
    IFEStep4ResultsDetailsDtoModel, IFEStep4ResultsDtoModel, IGetFEQuery, IQuerySpfr, ISPItem, IFEStep4, IFEStep4ResultadoEsperado
} from "@models/*";
import { Constants, Dictionary, Enums, Utilities, String } from "@utils";
import { SPSubProjectExtentionService } from "./spsubproject.extention.service";

export interface ISPFEService {
    getHeader(query: IQuerySpfr): Promise<IFEHeaderDto>;
    getDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>>;
    getSPFE(query: IGetFEQuery): Promise<any>;
    getStepOne(query: IGetFEQuery): Promise<any>;
    getStepTwo(query: IGetFEQuery): Promise<any>;
    getSDCStep(query: IGetFEQuery): Promise<any>;
    getStepThree(query: IGetFEQuery): Promise<any>;
    getStepFour(query: IGetFEQuery): Promise<any>;
    getStepFourMRI(query: IGetFEQuery): Promise<any>;
    saveFEStep1(step1: IFEStep1Dto, currentUserEmail: string): Promise<any>;
    saveFEStep2(step2: IFEStep2Dto): Promise<any>;
    saveFEStep3(step3: IFEStep3Dto): Promise<any>;
    saveSPFRStepSDC(stepSDC: any, userEmail: string): Promise<any>;
    saveGenericInfoObjetiveStep4(objetive: IFEStep4, userEmail: string): Promise<any>;
    saveGenericInfoREStep4(expectedResult: IFEStep4ResultadoEsperado, userEmail: string): Promise<any>;
    saveFEStep4(step4: Array<IFEStep4Dto>, step4Mri: Array<IFEStep4MriIndicadorDtoModel>, currentUserEmail: string): Promise<any>;
    saveObjetivesS4(step4: any, objetives: any, userEmail: string): Promise<any>;
    saveMriS4(step4Mri: any, userEmail: string): Promise<any>;
    createInfoStep4(stepInfo: any): Promise<any>;
    createResInfoStep4(stepInfo: any): Promise<any>;
    saveEspResults(result: IFEStep4ResultsDtoModel, resultResponse: ISPItem, userEmail: string): Promise<any>;
    saveActivities(result: IFEStep4ResultsDtoModel, resultResponse: ISPItem, userEmail: string, onlyModified?: boolean): Promise<any>;
}

export class SPFEService extends SPSubProjectExtentionService implements ISPFEService {
    public async getHeader(query: IQuerySpfr): Promise<IFEHeaderDto> {
        const budgetHeader: any = await this.getBudgetHeader(query.budgetId);
        let interventionLine = null;
        let objetive = null;
        let financierName = null;

        if (!Utilities.isNullEmptyObject(budgetHeader)) {
            interventionLine = this.getTraductionInterventionLine(query.langLabel, budgetHeader.OCTAVIALineaIntervencion, query.budgetId);
            const details = await this.getBudgetDetails(query.budgetId);
            const detailsFilter = details.filter((x: any) => x.PPresCodSubvencionId === query.subvCode);
            if (detailsFilter.length > 0) {
                let financiers: Array<string> = [];
                detailsFilter.forEach((item: any) => {
                    if (!Utilities.isNullEmptyObject(item.OCTAVIAFinanciadorSapId)) {
                        const financierName = this.getTitleTranslate(query.langLabel, item.OCTAVIAFinanciadorSap);
                        if (financiers.indexOf(financierName) === -1) {
                            financiers.push(financierName);
                        }
                    }
                });
                financierName = financiers.join(',');
            }

            if (!Utilities.isNullObject(interventionLine)) {
                let strategicLine: any = await this.getInterventionLineObjetive(interventionLine.Id);
                if (strategicLine.length > 0) {
                    let findObjetive: any = await this.getGapById(strategicLine[0].OCTAVIAGapLineaIntervencionId);
                    objetive = this.getTitleTranslate(query.langLabel, findObjetive);
                }
            }
        }
        let responseObject: IFEHeaderDto = {
            projectTitle: budgetHeader?.Title ?? '',
            projectCode: budgetHeader?.PPresCodProy ?? '',
            financier: financierName,
            strategicLine: interventionLine?.Title ?? '',
            strategicObjetive: objetive
        };
        return responseObject;
    }

    public async getBudgetDetails(budgetId: number): Promise<any> {

        const parentBudget: any = await this.spListService.getItems<any>({
            listName: Enums.ListTypes.BaseBudget,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_ID, budgetId),
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });

        const childsBudget: any = await this.spListService.getItems<any>({
            listName: Enums.ListTypes.BaseBudget,
            filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
            columnsToSelect: Constants.Selects.BUDGET_BASIC,
            expands: Constants.Expands.BUDGET_BASIC
        });

        let budgetIds = [parentBudget[0].Id];

        budgetIds = [...budgetIds, ...childsBudget.map((x: any) => { return x.Id })];

        let responseApi = await Promise.all(budgetIds.map(async (budgetId: number) => {
            return await this.spListService.getItems<any>({
                listName: Enums.ListTypes.DetailDataBudget,
                filter: String.Format(Constants.FiltersFormats.FILTER_BY_BUDGET, budgetId),
                columnsToSelect: Constants.Selects.BUDGET_DETAILS,
                expands: Constants.Expands.BUDGET_DETAILS
            });
        }));

        let finalArray: any = [];

        responseApi.forEach(x => {
            finalArray = [...finalArray, ...x]
        });
        return finalArray;
    }

    public async getDataColumns(langId: number): Promise<Dictionary<string, IAEAColumnDefinition>> {
        return await this.getDefinitionColumns(langId, Enums.ListTypes.ProaSubproyectoFEDefinicionColumnas);
    }

    public async getSPFE(query: IGetFEQuery): Promise<any> {

        let [step1, step2, step3, step4, stepSDC, step4Mri] = await Promise.all([
            this.getFEStep1(query),
            this.getFEStep2(query),
            this.getFEStep3(query),
            this.getFEStep4(query),
            this.getStepSDC(query),
            this.getFEStep4Mri(query)
        ]);

        return {
            step1,
            step2,
            step3,
            step4,
            stepSDC,
            step4Mri
        };
    }

    public async getStepOne(query: IGetFEQuery): Promise<any> {
        return await this.getFEStep1(query);
    }

    public async getStepTwo(query: IGetFEQuery): Promise<any> {
        return await this.getFEStep2(query);
    }

    public async getSDCStep(query: IGetFEQuery): Promise<any> {
        return await this.getStepSDC(query);
    }

    public async getStepThree(query: IGetFEQuery): Promise<any> {
        return await this.getFEStep3(query);
    }

    public async getStepFour(query: IGetFEQuery): Promise<any> {
        return await this.getFEStep4(query);
    }

    public async getStepFourMRI(query: IGetFEQuery): Promise<any> {
        return await this.getFEStep4Mri(query);
    }

    public async saveFEStep1(step1: IFEStep1Dto, currentUserEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail);

        if (step1.genericInfo.Id !== 0) {
            return await this.updateFEStep1(step1, currentUsu.Id);
        }
        else {
            return await this.saveFEStep1Back(step1, currentUsu.Id);
        }
    }

    public async saveFEStep2(step2: IFEStep2Dto): Promise<any> {
        return await this.updateFEStep2(step2);
    }

    public async saveFEStep3(step3: IFEStep3Dto): Promise<any> {
        return await this.updateFEStep3(step3);
    }

    public async saveObjetivesS4(step4: any, objetives: any, userEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(userEmail);
        return await this.saveFEStep4Objetives(objetives, step4, currentUsu.Id);
    }

    public async saveMriS4(step4Mri: any, userEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(userEmail);
        return await this.saveFEStep4Mri(step4Mri, currentUsu.Id);
    }

    public async createInfoStep4(stepInfo: any): Promise<any> {
        return await this.spListService.addItem({ listName: Enums.ListTypes.ProaSubproyectoFEStep4, item: stepInfo });
    }

    public async createResInfoStep4(stepInfo: any): Promise<any> {
        return await this.spListService.addItem({ listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados, item: stepInfo });
    }

    public async saveEspResults(result: IFEStep4ResultsDtoModel, resultResponse: ISPItem, userEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(userEmail);

        for (const detail of result.details) {
            let resultsToCreate: IFEStep4ResultadoEsperadoDetalleAnio[] = []
            let resultsToUpdate: IFEStep4ResultadoEsperadoDetalleAnio[] = []
            detail.genericInfo.PProaModifiedById = currentUsu.Id;
            (detail.genericInfo as any).PProaAnioLineaBase = detail.genericInfo.PProaAnioLineaBase ? `${(Number(detail.genericInfo.PProaAnioLineaBase.getMonth()) + 1)}/${detail.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;

            if (detail.genericInfo.Id === 0) {
                detail.genericInfo.PProaFEStep4ResultadosEsperadosId = (resultResponse as ISPItem).Id;
                let detailReponse = await this.createDetailsItems(detail.genericInfo);
                detail.genericInfo.Id = detailReponse.Id;
                let newResults = detail.years.map((year: IFEStep4ResultadoEsperadoDetalleAnio) => {
                    year.PProaFEStep4ResultadoDetalleId = detailReponse.Id;
                    return year;
                })
                resultsToCreate = [...resultsToCreate, ...newResults]
            }
            else {
                let detailReponse: any = await this.updateDetailsItems(detail.genericInfo)
                let yearsToCreate = detail.years.filter(y => {
                    if (y.Id === 0) {
                        y.PProaFEStep4ResultadoDetalleId = detailReponse.Id
                        return y;
                    }
                });
                let yearsToUpdate = detail.years.filter(y => y.Id !== 0);

                resultsToCreate = [...resultsToCreate, ...yearsToCreate]
                resultsToUpdate = [...resultsToUpdate, ...yearsToUpdate]
            }

            let years = await Promise.all([
                this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, resultsToCreate),
                this.spListService.updateItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, resultsToUpdate),
            ]);

            years[0].forEach((x: any, i: number) => {
                detail.years?.forEach((y: any) => {
                    if (!y?.Id && (Number(x?.data?.PPresAnioMeta) === Number(y.PPresAnioMeta))) y.Id = x?.data?.Id;
                })
            })
        };

        return result;
    }

    private areYearsEqual(arr1: any[], arr2: any[]): boolean {
        if (arr1.length !== arr2.length) {
            return false;
        }

        for (const [index, year1] of arr1.entries()) {
            const year2 = arr2[index]
            for (const key in year1) {
                if (year1.hasOwnProperty(key) && year2.hasOwnProperty(key)) {
                    const val1 = year1[key].toString();
                    const val2 = year2[key].toString();

                    if (val1 !== val2) {
                        return false;
                    }
                }
            }
        }

        return true;
    }

    private areActivitiesEqual(act1Data: any, act2Data: any): boolean {
        const act1 = act1Data.genericInfo;
        const act2 = act2Data.genericInfo;

        for (const key in act1) {
            if (act1.hasOwnProperty(key) && act2.hasOwnProperty(key)) {
                const val1 = act1[key];
                const val2 = act2[key];

                if (val1 !== val2) {
                    return false;
                }
            }
        }

        const yearsAct1 = act1Data.years;
        const yearsAct2 = act2Data.years;

        return this.areYearsEqual(yearsAct1, yearsAct2);
    }

    public async saveActivities(result: IFEStep4ResultsDtoModel, resultResponse: ISPItem, userEmail: string, modifiedFlag: boolean = false): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(userEmail);

        for (const [index, activity] of result.activities.entries()) {
            if (modifiedFlag && activity.genericInfo?.isModified == true || modifiedFlag == false) {
                if (modifiedFlag) delete activity.genericInfo.isModified;
                let activitiesToCreate: IFEStep4ActividadAnio[] = []
                let activitiesToUpdate: IFEStep4ActividadAnio[] = []
                activity.genericInfo.PProaModifiedById = currentUsu.Id;

                if (activity.genericInfo.Id === 0) {
                    activity.genericInfo.PProaFEStep4ResultadosEsperadosId = (resultResponse as ISPItem).Id;
                    let activityResult = await this.createActivityItems(activity.genericInfo);
                    activity.genericInfo.Id = activityResult.Id;
                    let newActivities = activity.years.map((year: IFEStep4ActividadAnio) => {
                        year.PProaFEStep4ActividadId = activityResult.Id;
                        return year;
                    })
                    activitiesToCreate = [...activitiesToCreate, ...newActivities]
                }
                else {
                    let activityResult: any = await this.updateActivityItems(activity.genericInfo);
                    let yearsToCreate = activity.years.filter(y => {
                        if (y.Id === 0) {
                            y.PProaFEStep4ActividadId = activityResult.Id;
                            return y;
                        }
                    });
                    let yearsToUpdate = activity.years.filter(y => y.Id !== 0);
                    activitiesToCreate = [...activitiesToCreate, ...yearsToCreate]
                    activitiesToUpdate = [...activitiesToUpdate, ...yearsToUpdate]
                }

                if (activitiesToCreate.length > 0 || activitiesToUpdate.length > 0) {
                    let years = await Promise.all([
                        this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, activitiesToCreate),
                        this.spListService.updateItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, activitiesToUpdate)
                    ]);

                    years[0].forEach((x: any, i: number) => {
                        activity.years?.forEach((y: any) => {
                            if (!y?.Id && (Number(x?.data?.PPresAnioMeta) === Number(y.PPresAnioMeta))) y.Id = x?.data?.Id;
                        })
                    })
                }
            }
        };

        return result;
    }

    public async saveGenericInfoObjetiveStep4(objetive: IFEStep4, currentUserEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail);

        if (objetive.Id && 0 !== objetive.Id) {
            return await this.spListService.updateItem({
                listName: Enums.ListTypes.ProaSubproyectoFEStep4,
                item: objetive,
                itemId: objetive.Id
            });
        } else {
            return await this.spListService.addItem({
                listName: Enums.ListTypes.ProaSubproyectoFEStep4,
                item: objetive
            });
        }
    }

    public async saveFEStep4(step4: IFEStep4Dto[], step4Mri: IFEStep4MriIndicadorDtoModel[], currentUserEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail);

        return await Promise.all([this.saveFEStep4Mri(step4Mri, currentUsu.Id),
        ...step4.map(async (element: IFEStep4Dto) => {
            let step4Response = null;

            if (element.genericInfo.Id && 0 !== element.genericInfo.Id) {
                step4Response = await this.spListService.updateItem({
                    listName: Enums.ListTypes.ProaSubproyectoFEStep4,
                    item: element.genericInfo,
                    itemId: element.genericInfo.Id
                });
            } else {
                step4Response = await this.spListService.addItem({
                    listName: Enums.ListTypes.ProaSubproyectoFEStep4,
                    item: element.genericInfo
                });
            }

            return await Promise.all([
                this.saveFEStep4Objetives(element.objetives, step4Response, currentUsu.Id),
                this.saveFEStep4ExpectedResults(element.results, step4Response, currentUsu.Id)
            ]);
        })
        ]);
    }

    //#region Expected Results

    public async saveGenericInfoREStep4(expectedResult: IFEStep4ResultadoEsperado, userEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(userEmail);

        if (expectedResult.Id && 0 !== expectedResult.Id) {
            return await this.spListService.updateItem({
                listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
                item: expectedResult,
                itemId: expectedResult.Id
            });
        } else {
            return await this.spListService.addItem({
                listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
                item: expectedResult
            });
        }
    }

    private async saveFEStep4ExpectedResults(results: IFEStep4ResultsDtoModel[], step4Response: ISPItem, userId: number) {
        for (const result of results) {
            for (const detail of result.details) {
                detail.genericInfo.PProaModifiedById = userId;
                (detail.genericInfo as any).PProaAnioLineaBase = detail.genericInfo.PProaAnioLineaBase ? `${(Number(detail.genericInfo.PProaAnioLineaBase.getMonth()) + 1)}/${detail.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;
            };
            for (const activity of result.activities) {
                activity.genericInfo.PProaModifiedById = userId;
            };
        };

        return await Promise.all(results.map(async (result: IFEStep4ResultsDtoModel) => {
            result.genericInfo.PProaFEStep4Id = step4Response.Id;
            if (0 === result.genericInfo.Id) {
                return await this.saveNewExpectedResult(result);
            } else {
                return await this.updateExistentExpectedResult(result);
            }
        }));
    }

    private async saveNewExpectedResult(result: IFEStep4ResultsDtoModel) {
        let resultResponse = await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
            item: result.genericInfo
        });

        let resultsToCreate: IFEStep4ResultadoEsperadoDetalleAnio[] = []
        for (const detail of result.details) {
            detail.genericInfo.PProaFEStep4ResultadosEsperadosId = resultResponse.Id;
            let detailReponse = await this.createDetailsItems(detail.genericInfo);
            let newResults = detail.years.map((year: IFEStep4ResultadoEsperadoDetalleAnio) => {
                year.PProaFEStep4ResultadoDetalleId = detailReponse.Id;
                return year;
            })
            resultsToCreate = [...resultsToCreate, ...newResults]
        };

        let activitiesToCreate: IFEStep4ActividadAnio[] = []
        for (const activity of result.activities) {
            activity.genericInfo.PProaFEStep4ResultadosEsperadosId = resultResponse.Id;
            let activityResult = await this.createActivityItems(activity.genericInfo);
            let newActivities = activity.years.map((year: IFEStep4ActividadAnio) => {
                year.PProaFEStep4ActividadId = activityResult.Id;
                return year;
            })
            activitiesToCreate = [...activitiesToCreate, ...newActivities]
        };

        let res = await Promise.all([
            this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, resultsToCreate),
            this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, activitiesToCreate),
        ]);

        this.addProgress(5);
        return res;
    }

    private async updateExistentExpectedResult(result: IFEStep4ResultsDtoModel) {
        let resultResponse = await this.spListService.updateItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
            item: result.genericInfo,
            itemId: result.genericInfo.Id
        });

        let resultsToCreate: IFEStep4ResultadoEsperadoDetalleAnio[] = []
        let resultsToUpdate: IFEStep4ResultadoEsperadoDetalleAnio[] = []
        for (const detail of result.details) {
            if (detail.genericInfo.Id === 0) {
                detail.genericInfo.PProaFEStep4ResultadosEsperadosId = (resultResponse as ISPItem).Id;
                let detailReponse = await this.createDetailsItems(detail.genericInfo);
                let newResults = detail.years.map((year: IFEStep4ResultadoEsperadoDetalleAnio) => {
                    year.PProaFEStep4ResultadoDetalleId = detailReponse.Id;
                    return year;
                })
                resultsToCreate = [...resultsToCreate, ...newResults]
            }
            else {
                let detailReponse: any = await this.updateDetailsItems(detail.genericInfo)
                let yearsToCreate = detail.years.filter(y => {
                    if (y.Id === 0) {
                        y.PProaFEStep4ResultadoDetalleId = detailReponse.Id
                        return y;
                    }
                });
                let yearsToUpdate = detail.years.filter(y => y.Id !== 0);

                resultsToCreate = [...resultsToCreate, ...yearsToCreate]
                resultsToUpdate = [...resultsToUpdate, ...yearsToUpdate]
            }
        };

        let activitiesToCreate: IFEStep4ActividadAnio[] = []
        let activitiesToUpdate: IFEStep4ActividadAnio[] = []
        for (const activity of result.activities) {
            if (activity.genericInfo.Id === 0) {
                activity.genericInfo.PProaFEStep4ResultadosEsperadosId = (resultResponse as ISPItem).Id;
                let activityResult = await this.createActivityItems(activity.genericInfo);
                let newActivities = activity.years.map((year: IFEStep4ActividadAnio) => {
                    year.PProaFEStep4ActividadId = activityResult.Id;
                    return year;
                })
                activitiesToCreate = [...activitiesToCreate, ...newActivities]
            }
            else {
                let activityResult: any = await this.updateActivityItems(activity.genericInfo);
                let yearsToCreate = activity.years.filter(y => {
                    if (y.Id === 0) {
                        y.PProaFEStep4ActividadId = activityResult.Id;
                        return y;
                    }
                });
                let yearsToUpdate = activity.years.filter(y => y.Id !== 0);

                activitiesToCreate = [...activitiesToCreate, ...yearsToCreate]
                activitiesToUpdate = [...activitiesToUpdate, ...yearsToUpdate]
            }
        };

        let res = await Promise.all([
            this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, resultsToCreate),
            this.spListService.updateItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios, resultsToUpdate),
            this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, activitiesToCreate),
            this.spListService.updateItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios, activitiesToUpdate)
        ]);

        this.addProgress(5);
        return res;
    }

    private async createDetailsItems(detail: IFEStep4ResultadoEsperadoDetalle) {
        return await this.spListService.addItem({
            item: detail,
            listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles
        });
    }

    private async updateDetailsItems(detail: IFEStep4ResultadoEsperadoDetalle) {
        return await this.spListService.updateItem({
            item: detail,
            listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles,
            itemId: detail.Id
        });
    }

    private async createActivityItems(activity: IFEStep4Actividad) {
        return await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
            item: activity
        })
    }

    private async updateActivityItems(activity: IFEStep4Actividad) {
        return await this.spListService.updateItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
            item: activity,
            itemId: activity.Id
        })
    }

    //#endregion

    //#region Objetives
    private async saveFEStep4Objetives(objetives: IFEStep4IndicadoresDtoModel[], step4Response: ISPItem, userId: number) {
        return await Promise.all(objetives.map(async (objetive: IFEStep4IndicadoresDtoModel) => {
            objetive.genericInfo.PProaModifiedById = userId;
            (objetive.genericInfo as any).PProaAnioLineaBase = objetive.genericInfo.PProaAnioLineaBase ? `${(Number(objetive.genericInfo.PProaAnioLineaBase.getMonth()) + 1)}/${objetive.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;

            if (0 === objetive.genericInfo.Id) {
                objetive.genericInfo.PProaFEStep4Id = step4Response.Id
                return await this.saveNewObjetives(objetive);
            } else {
                return await this.updateExistentObjetive(objetive);
            }
        }));
    }

    private async saveNewObjetives(objetive: IFEStep4IndicadoresDtoModel) {
        let _objetive = await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
            item: objetive.genericInfo
        });

        let newYears = objetive.years.map((year: IFEStep4IndicadorObjetivoAnio) => {
            year.PProaFEStep4InidicadorId = _objetive.Id;
            return year;
        })

        let years = await this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios, newYears)
        this.addProgress(3);
        _objetive.years = years

        return _objetive;
    }

    private async updateExistentObjetive(objetive: IFEStep4IndicadoresDtoModel) {
        let _objetive: any = await this.spListService.updateItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
            item: objetive.genericInfo,
            itemId: objetive.genericInfo.Id
        });

        let yearsToCreate: any = []
        let yearsToUpdate: any = []
        for (const y of objetive.years) {
            y.PProaFEStep4InidicadorId = _objetive.Id;
            if (y.Id === 0) yearsToCreate.push(y)
            else if (y.Id !== 0) yearsToUpdate.push(y)
        }

        let years = await Promise.all([
            this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios, yearsToCreate),
            this.spListService.updateItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios, yearsToUpdate)
        ]);

        _objetive.years = years[0]
        this.addProgress(3);
        return _objetive;
    }

    protected createLookupObjectMultiValue(values: any) {
        return { '__metadata': { type: 'Collection(Edm.Int32)' }, results: values };
    }
    public async saveSPFRStepSDC(stepSDC: any, currentUserEmail: string): Promise<any> {
        let currentUsu = await this.spWebService.ensureUser(currentUserEmail);
        return await this.updateStepSDC(stepSDC, stepSDC.budgetId, currentUsu.Id);
    }
    //#endregion Objetives

    //#region MRIIndicators
    private async saveFEStep4Mri(mriIndicators: IFEStep4MriIndicadorDtoModel[], userId: number) {
        return await Promise.all(mriIndicators.map(async (mriIndicator: IFEStep4MriIndicadorDtoModel) => {
            if (0 === mriIndicator.genericInfo.Id) {
                return await this.saveNewMri(mriIndicator, userId);
            } else {
                return await this.updateExistentMri(mriIndicator, userId);
            }
        }));
    }

    private async saveNewMri(mri: IFEStep4MriIndicadorDtoModel, userId: number) {
        (mri.genericInfo as any).PFFRRIndicadorResultadoIntermediId = this.createLookupObjectMultiValue({ ...mri.genericInfo }.PFFRRIndicadorResultadoIntermedioId);
        delete mri.genericInfo.PFFRRIndicadorResultadoIntermedioId;

        (mri.genericInfo as any).PProaAnioLineaBase = mri.genericInfo.PProaAnioLineaBase ? `${(Number(mri.genericInfo.PProaAnioLineaBase.getMonth()) + 1)}/${mri.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;
        (mri.genericInfo as any).PProaModifiedById = userId;

        let _mri: any = await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
            item: mri.genericInfo
        });

        let mriYearsToCreate = mri.years.map((year: IFEStep4MriIndicadorAnio) => {
            year.PProaStep4AdaptacionMRIId = _mri.Id;
            return year;
        })

        let years = await this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios, mriYearsToCreate)
        _mri.years = years

        return _mri
    }

    private async updateExistentMri(mri: IFEStep4MriIndicadorDtoModel, userId: number) {
        (mri.genericInfo as any).PFFRRIndicadorResultadoIntermediId = this.createLookupObjectMultiValue({ ...mri.genericInfo }.PFFRRIndicadorResultadoIntermedioId);
        delete mri.genericInfo.PFFRRIndicadorResultadoIntermedioId;

        (mri.genericInfo as any).PProaAnioLineaBase = mri.genericInfo.PProaAnioLineaBase ? `${(Number(mri.genericInfo.PProaAnioLineaBase.getMonth()) + 1)}/${mri.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;
        (mri.genericInfo as any).PProaModifiedById = userId;

        let _mri: any = await this.spListService.updateItem({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
            item: mri.genericInfo,
            itemId: mri.genericInfo.Id
        });

        let mriYearsToCreate: any = []
        let mriYearsToUpdate: any = []
        for (const y of mri.years) {
            y.PProaStep4AdaptacionMRIId = _mri.Id;
            if (y.Id === 0) mriYearsToCreate.push(y)
            else if (y.Id !== 0) mriYearsToUpdate.push(y)
        }

        let years = await Promise.all([
            this.spListService.addItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios, mriYearsToCreate),
            this.spListService.updateItemsBatch(Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios, mriYearsToUpdate)
        ]);

        _mri.years = years[0]

        return _mri
    }
    //#endregion MRIIndicators

    private async addProgress(add: number) {
        let labelProgress = document.getElementById('labelProgress');
        let myBar = document.getElementById('myBar');
        let progress = (Number(labelProgress?.innerText?.substring(0, 2)) + add) || 99;
        let newValue = (progress < 100) ? progress + '%' : '99%';
        labelProgress.innerText = newValue;
        myBar.style.width = newValue;
    }
}